module.exports = __webpack_public_path__ + "img/feature-1.ed254c40.png";